export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export const testimonials = [
  {
    name: "Marcus T.",
    role: "Sneaker Collector",
    content: "The Nike spreadsheet on CSSBuy Sheet saved me hours of searching. Found my grail Dunks at half the market price through a verified seller listed here. Absolutely the best resource for any sneakerhead using shopping agents.",
    rating: 5,
  },
  {
    name: "Priya K.",
    role: "Streetwear Enthusiast",
    content: "I was skeptical about using shopping agents until I found the comprehensive guide on CSSBuy Sheet. The curated seller links for Stussy and Essentials are spot-on. Every link I tried was legitimate with real QC photos.",
    rating: 5,
  },
  {
    name: "David L.",
    role: "First-time Buyer",
    content: "The shipping guide alone is worth bookmarking this site. Combined with the category spreadsheets, I went from confused to confident in one afternoon. Shipped my first 5kg haul without any issues thanks to the tips here.",
    rating: 5,
  },
  {
    name: "Sophie M.",
    role: "Fashion Blogger",
    content: "As someone who regularly sources pieces from China, CSSBuy Sheet has become my go-to directory. The Chrome Hearts and Balenciaga spreadsheet links are always up to date, and the QC guide helped me avoid bad batches.",
    rating: 5,
  },
  {
    name: "Alex R.",
    role: "Reseller",
    content: "Been using shopping agents for 3 years and this is hands down the most organized spreadsheet resource I have seen. The category breakdown makes it easy to find exactly what I need. My go-to for restocking inventory.",
    rating: 5,
  },
  {
    name: "Jamal W.",
    role: "College Student",
    content: "On a tight budget but still want quality pieces. The CSSBuy Sheet directory helped me find affordable alternatives and budget-friendly seller links. The comparison tables between agents are incredibly helpful for saving on fees.",
    rating: 5,
  },
];